import { useFormContext } from 'react-hook-form';
import { Checkbox } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { useGetPreContractualInformationMutation } from '@app/api/preContractualApi';
import { InlineSpinner } from '@app/components/InlineSpinner';
import { getLegalUrl } from '@app/configs/documentsLists';
import { DocumentTypes } from '@app/configs/loanApplication';
import { getUserLocale } from '@app/utils/getUserLocale';
const PreContractualAgreements = ({ period, amount }) => {
    const { t } = useTranslation();
    const locale = getUserLocale();
    const [getPreContractualInformation, { isLoading: loadingInformation }] = useGetPreContractualInformationMutation();
    const { register, formState: { errors }, } = useFormContext();
    const handlePreContractualInformation = (event) => {
        event.preventDefault();
        getPreContractualInformation({
            period,
            amount,
            documentType: DocumentTypes.PreContractualAgreement,
        });
    };
    return (<>
            <p className="text-sm font-bold leading-4 mt-4 mb-2">
                {t('financing.loan_application.read_and_agree_documents')}
            </p>
            <div className="flex items-baseline gap-2">
                <Checkbox className="min-w-4 items-start" variant={errors.isGeneralConditionsAccepted ? 'critical' : 'default'} {...register('isGeneralConditionsAccepted')} label={<>
                            {`${t('financing.loan_application.checkbox_title')} `}
                            <a href={getLegalUrl('generalConditions', locale)} className="text-blue-600 underline hover:text-blue-800" target="_blank" rel="noreferrer">
                                {t('financing.loan_application.general_conditions')}
                            </a>
                        </>}/>
            </div>
            <div className="flex items-baseline gap-2 mb-4">
                <Checkbox className="min-w-4 items-start" variant={errors.isPreContractualInformationAccepted ? 'critical' : 'default'} {...register('isPreContractualInformationAccepted')} label={<>
                            {`${t('financing.loan_application.checkbox_title')} `}
                            <button type="button" onClick={handlePreContractualInformation} className="text-blue-600 underline hover:no-underline hover:text-blue-800">
                                {t('financing.loan_application.pre_contractual_information')}
                            </button>
                            <InlineSpinner isLoading={loadingInformation}/>
                        </>}/>
            </div>
            {(errors.isGeneralConditionsAccepted || errors.isPreContractualInformationAccepted) && (<p className="text-red-500 text-sm font-normal my-2">
                    {t('financing.loan_application.agreement_validation_error')}
                </p>)}
        </>);
};
export default PreContractualAgreements;
